import styled from "styled-components";

export const ThumbNailWrapper = styled.div`
    display: flex;
    align-items: center;
    float: right;
`;